import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { companyInfo } from '../mockData';
import { trackWhatsAppClick } from '../utils/analytics';

export const FloatingWhatsApp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const whatsappNumber = companyInfo.whatsapp.replace(/\s/g, '');
  
  const handleSendMessage = () => {
    const defaultMessage = message || 'Merhaba, ürünleriniz hakkında bilgi almak istiyorum.';
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;
    
    // Google Analytics ile WhatsApp tıklamasını izle
    trackWhatsAppClick('floating_button');
    
    window.open(whatsappUrl, '_blank');
    setMessage('');
    setIsOpen(false);
  };

  // Çalışma saatleri kontrolü
  const now = new Date();
  const hour = now.getHours();
  const day = now.getDay();
  const isWorkingHours = day !== 0 && hour >= 8 && hour < 18; // Pazar hariç 08:00-18:00

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Ana WhatsApp Butonu */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="group relative bg-[#25D366] text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 animate-pulse hover:animate-none"
        aria-label="WhatsApp ile iletişime geç"
      >
        {isOpen ? (
          <X size={28} className="transition-transform duration-200" />
        ) : (
          <MessageCircle size={28} className="transition-transform duration-200" />
        )}
        
        {/* Pulse efekti */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75"></span>
        
        {/* Hover tooltip */}
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
          WhatsApp ile yazın
        </span>
      </button>

      {/* Açılır Mesaj Kutusu */}
      {isOpen && (
        <div className="absolute bottom-20 right-0 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden animate-in slide-in-from-bottom-5 duration-300">
          {/* Header */}
          <div className="bg-[#25D366] text-white p-4">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <MessageCircle size={24} className="text-[#25D366]" />
              </div>
              <div>
                <h3 className="font-semibold text-lg">WhatsApp Destek</h3>
                <p className="text-xs text-white/90">
                  {isWorkingHours ? (
                    <span className="flex items-center">
                      <span className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></span>
                      Çevrimiçi - Hemen Yanıt
                    </span>
                  ) : (
                    <span className="flex items-center">
                      <span className="w-2 h-2 bg-gray-300 rounded-full mr-2"></span>
                      Mesaj bırakın, dönelim
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="p-4">
            <div className="bg-gray-50 rounded-lg p-3 mb-4">
              <p className="text-sm text-gray-700 mb-2">
                👋 Merhaba! Size nasıl yardımcı olabiliriz?
              </p>
              <p className="text-xs text-gray-500">
                Ürünlerimiz, fiyatlar ve sipariş hakkında sorularınızı yanıtlamak için buradayız.
              </p>
            </div>

            {/* Hızlı Mesaj Şablonları */}
            <div className="space-y-2 mb-4">
              <button
                onClick={() => setMessage('Apache buğday tohumu hakkında bilgi almak istiyorum.')}
                className="w-full text-left text-sm bg-gray-50 hover:bg-gray-100 p-3 rounded-lg transition-colors"
              >
                🌾 Apache buğday tohumu bilgisi
              </button>
              <button
                onClick={() => setMessage('Bonus pamuk tohumu fiyatı nedir?')}
                className="w-full text-left text-sm bg-gray-50 hover:bg-gray-100 p-3 rounded-lg transition-colors"
              >
                🌱 Bonus pamuk fiyat bilgisi
              </button>
              <button
                onClick={() => setMessage('Toptan alım yapmak istiyorum.')}
                className="w-full text-left text-sm bg-gray-50 hover:bg-gray-100 p-3 rounded-lg transition-colors"
              >
                📦 Toptan alım
              </button>
            </div>

            {/* Mesaj Input */}
            <div className="mb-3">
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Mesajınızı yazın..."
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#25D366] focus:border-transparent resize-none text-sm"
                rows="3"
              />
            </div>

            {/* Gönder Butonu */}
            <button
              onClick={handleSendMessage}
              className="w-full bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
            >
              <MessageCircle size={20} />
              <span>WhatsApp'ta Gönder</span>
            </button>

            {/* Çalışma Saatleri */}
            <div className="mt-3 text-center">
              <p className="text-xs text-gray-500">
                {companyInfo.workingHours}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
